<template>
  <apexchart
    type="area"
    :height="height"
    :width="width"
    :options="chartOptions"
    :series="series"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { ApexChartsLocale } from '@/data/models/ApexchartsLocale'
import i18n from '@/plugins/i18n'

export default {
  name: 'SparklineChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    series: {
      type: Array,
      required: true
    },
    color: {
      type: String,
      default: '#9e9e9e'
    },
    height: {
      type: Number,
      default: 30
    },
    width: {
      type: Number,
      default: undefined
    },
    animations: {
      type: Object,
      default: () => ({})
    },
    tooltip: {
      type: Object,
      default: () => ({
        enabled: true,
        fixed: {
          enabled: true
        },
        x: {
          show: false
        },
        y: {
          show: false
        },
        marker: {
          show: false
        }
      })
    }
  },
  computed: {
    chartOptions() {
      return {
        colors: [this.color],
        chart: {
          type: 'area',
          sparkline: {
            enabled: true
          },
          animations: this.animations,
          height: this.height,
          locales: ApexChartsLocale,
          defaultLocale: i18n.locale
        },
        xaxis: {
          type: 'numeric',
          crosshairs: {
            width: 1
          }
        },
        fill: {
          opacity: 0.3
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        tooltip: this.tooltip
      }
    }
  }
}
</script>
